import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./userForm.data.form";
// import InputSelect from "../../../utils/InputSelect";
import {
  InputSelect,
  InputCheck,
  InputAutoComplete,
  InputText,
} from "@de-prado-dev/react-component-library";
import { ROLES } from "../../../../constants";
import { Container } from "./userForm.styled";

const UserForm = (props) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    onBack,
    edit,
    viveros,
    users,
    onFilterUser,
    onCheckCreate,
    checkCreate,
  } = props;

  const roles = ROLES.map((rol) => {
    return { value: rol, label: t(rol) };
  });

  const renderListUser = (item) => {
    return item.completeName;
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.users.titleEdit") : t("forms.users.titleNew")}
          </h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="userUuid"
                  className="form-control"
                  labelField={t("forms.users.labels.search")}
                  name="userUuid"
                  mandatory
                  component={InputAutoComplete}
                  fieldType="text"
                  onSearch={onFilterUser}
                  optionValue="uuid"
                  optionLabel="completeName"
                  textButtonReset={t("clear")}
                  renderItems={renderListUser}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="create"
                  labelField={t("forms.users.labels.create")}
                  name="create"
                  placeholder=""
                  component={InputCheck}
                  onChangeValue={(e) => {
                    onCheckCreate(e);
                  }}
                />
              </div>
            </div>
            {checkCreate && (
              <>
                <div className="row mt-2">
                  <div className="col-12">
                    <div className="alert alert-warning" role="alert">
                      {t("forms.users.warningUser")}
                    </div>
                  </div>
                </div>
                <Container>
                  <div className="row">
                    <div className="col-12">
                      <Field
                        id="name"
                        className="form-control"
                        labelField={t("forms.users.labels.name")}
                        name="name"
                        mandatory
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      <Field
                        id="surname1"
                        className="form-control"
                        labelField={t("forms.users.labels.surname1")}
                        name="surname1"
                        mandatory
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                    <div className="col-6">
                      <Field
                        id="surname2"
                        className="form-control"
                        labelField={t("forms.users.labels.surname2")}
                        name="surname2"
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      <Field
                        id="email"
                        className="form-control"
                        labelField={t("forms.users.labels.email")}
                        name="email"
                        mandatory
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                    <div className="col-6">
                      <Field
                        id="nif"
                        className="form-control"
                        labelField={t("forms.users.labels.nif")}
                        name="nif"
                        mandatory
                        component={InputText}
                        fieldType="text"
                      />
                    </div>
                  </div>
                </Container>
              </>
            )}

            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="viveroUuid"
                  name="viveroUuid"
                  labelField={t("forms.users.labels.vivero")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="uuid"
                  options={viveros.map((item) => ({
                    ...item,
                    label: item.name,
                  }))}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-2">
                <Field
                  id="roles"
                  name="roles"
                  labelField={t("forms.users.labels.roles")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="value"
                  options={roles}
                  classNamePrefix="dark"
                  mandatory
                  isMultiple
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="active"
                  labelField={t("forms.sector.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.users.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.users.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

UserForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  edit: PropTypes.bool,
};

const UserFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit, props.checkCreate);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "UserForm",
})(UserForm);

export default UserFormF;
